export default "__VITE_ASSET__BJK5vtEE__"